/*
 * Copyright (c) 2022. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {Resource} from "../../api/resource";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {TipoEnvio} from "./tipo-envio.model";
import {ManagerCachingStrategy} from "../../basic-entity-back/basic-entity-interface/mapping-external";

@BasicEntity({
    name: 'Transportista',
    endpoint: 'transportistas',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'nombre',
    type: 'Transportista',
    managerCaching: ManagerCachingStrategy.Lazy
})
export class Transportista extends Resource {

    @BasicProperty({
        name: 'ID',
        isId: true,
        type: PropertyType.Integer()
    })
    private _id;

    @BasicProperty({
        name: 'Nombre',
        type: PropertyType.String(),
    })
    private _nombre;

    @BasicProperty({
        name: 'Clase transportista',
        type: PropertyType.String(),
    })
    private _claseTransportista;

    @BasicProperty({
        name: 'Tipos de envío',
        type: PropertyType.NestedModel(TipoEnvio, null, NestedBehavior.SendIriOnly),
        array: true,
    })
    private _tiposEnvio;


    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get nombre() {
        return this._nombre;
    }

    set nombre(value) {
        this._nombre = value;
    }

    get claseTransportista() {
        return this._claseTransportista;
    }

    set claseTransportista(value) {
        this._claseTransportista = value;
    }

    get tiposEnvio() {
        return this._tiposEnvio;
    }

    set tiposEnvio(value) {
        this._tiposEnvio = value;
    }
}
